import { HotelReserveBookingCardDetail } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card-detail";
import { HotelReserveBookingCardWrapper } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card-wrapper";
import { HotelReserveBookingCardType } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card.type";
import useReverseBookingModal from "@website/accommodation-ui/hotel-reserve-booking-card/use-reverse-booking-modal";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { Modal } from "@website/ui/modal";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { useRouter } from "next/router";
import { FC, memo } from "react";
import SnappPayLogo from "./assets/snapp_pay_logo.png";

const Component: FC<HotelReserveBookingCardType> = (properties) => {
  const {
    isLoading,
    nightCount,
    minStay,
    passengersCount = 0,
    total_price,
    price,
    basePrice,
    submitDisabled,
    submitDisabledMessage,
    showMinStayAlarm,
    snappPayData
  } = properties;
  const { onModalClose, isReservePageOpen, onModalOpen } =
    useReverseBookingModal();

  const router = useRouter();

  const submitDisabledMessageError = (
    <p className="text-error text-caption">{submitDisabledMessage}</p>
  );

  const noDateMessage = (
    <div className="flex flex-col items-start gap-1">
      <div className="text-caption text-on-surface-medium-emphasis">
        قیمت از شبی
      </div>
      <div className="text-body-1">
        {`${numberConvert(numberSeparator(basePrice), {
          locale: router.locale
        })} تومان`}
      </div>
    </div>
  );
  return (
    <>
      <div
        className={`${
          snappPayData?.isEligible && snappPayData?.showDownPayment
            ? ""
            : "border-outline-thin border"
        } bg-on-color-high-emphasis shadow-6 fixed inset-x-0 bottom-0 z-20 w-full lg:hidden lg:min-h-[97px]`}
      >
        {snappPayData?.isEligible && snappPayData?.showDownPayment && (
          <>
            <div className="flex flex-row items-center gap-1 px-6 py-4">
              <LazyImage src={SnappPayLogo?.src} width={16} height={16} />
              <span className="text-caption text-on-surface-medium-emphasis">
                امکان پرداخت قسطی با اسنپ‌‌پی
              </span>
            </div>
            <div className="bg-outline-thin h-px w-full" />
          </>
        )}
        <div className="grid grid-cols-2 gap-2 px-6 pb-6 pt-4">
          <div className="flex flex-col gap-2">
            <div className="text-body-1 text-on-surface-high-emphasis">
              {router?.query?.["date_from"] &&
              router?.query?.["date_to"] &&
              passengersCount > 0 ? (
                <>
                  <div>
                    {total_price
                      ? `${numberConvert(numberSeparator(total_price), {
                          locale: router.locale
                        })} تومان`
                      : price
                        ? `${numberConvert(numberSeparator(price), {
                            locale: router.locale
                          })} تومان`
                        : null}
                  </div>
                  {minStay && showMinStayAlarm ? (
                    <div className="text-error text-caption pt-4">
                      {`${numberConvert(minStay, {
                        locale: router.locale
                      })} شب حداقل مدت اقامت`}
                    </div>
                  ) : (
                    <div />
                  )}
                </>
              ) : (
                <></>
              )}
              {submitDisabledMessage && !isLoading
                ? submitDisabledMessageError
                : !router?.query?.["date_from"] ||
                    !router?.query?.["date_to"] ||
                    passengersCount === 0
                  ? noDateMessage
                  : `${numberConvert(nightCount, {
                      locale: router.locale
                    })} شب برای ${numberConvert(passengersCount, {
                      locale: router.locale
                    })} نفر`}
            </div>
          </div>
          <Button
            className="mt-auto"
            disabled={
              (!isLoading &&
                submitDisabled &&
                Boolean(
                  router?.query?.["date_from"] && router?.query?.["date_to"]
                )) ||
              Number(nightCount) < Number(properties?.minStay)
            }
            fullWidth
            loading={isLoading}
            onClick={onModalOpen}
            size="large"
          >
            {router?.query?.["date_from"] && router?.query?.["date_to"]
              ? "درخواست رزرو"
              : "انتخاب تاریخ"}
          </Button>
        </div>
      </div>
      <div className="hidden lg:block">
        <HotelReserveBookingCardWrapper>
          <HotelReserveBookingCardDetail {...properties} />
        </HotelReserveBookingCardWrapper>
      </div>
      <div className="block lg:hidden">
        <Modal
          closeIcon="arrow_forward"
          headerStyle="block h-[64px]"
          onClose={onModalClose}
          open={isReservePageOpen}
          showCloseButton
          iconClassName="!mr-0"
        >
          <HotelReserveBookingCardWrapper classes="flex flex-col justify-between">
            <HotelReserveBookingCardDetail
              {...properties}
              datePickerIsOpenAtInit={
                !(router?.query?.["date_from"] && router?.query?.["date_to"])
              }
            />
          </HotelReserveBookingCardWrapper>
        </Modal>
      </div>
    </>
  );
};

export const HotelReserveBookingCard = memo(Component, deepCompare);
